import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, redirectTo, roles }) => {
  const location = useLocation();
  const { isAuthenticated, isLoading, user, userPrimaryRoute } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-orange-500" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const fallbackRedirect = roles?.includes("admin") ? "/admin-login" : "/login";
    return (
      <Navigate
        to={redirectTo || fallbackRedirect}
        replace
        state={{ from: location }}
      />
    );
  }

  if (roles?.length && !roles.includes(user?.role)) {
    return <Navigate to={userPrimaryRoute} replace />;
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
